import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";

const statusConfig: Record<string, { bg: string; color: string }> = {
  Chase: { bg: "rgba(255, 152, 0, 0.15)", color: "rgb(230, 126, 0)" },
  "Signed Up": { bg: "rgba(33, 150, 243, 0.12)", color: "rgb(21, 101, 192)" },
  "Signed Up - Not Started": { bg: "rgba(103, 58, 183, 0.10)", color: "rgb(81, 45, 168)" },
  "In Treatment": { bg: "rgba(76, 175, 80, 0.12)", color: "rgb(46, 125, 50)" },
  "Discharged - Completed": { bg: "rgba(0, 0, 0, 0.06)", color: "rgba(0, 0, 0, 0.54)" },
  "Discharged - Not Started": { bg: "rgba(0, 0, 0, 0.04)", color: "rgba(0, 0, 0, 0.42)" },
  "Never Signed Up": { bg: "rgba(244, 67, 54, 0.10)", color: "rgb(198, 40, 40)" },
  Cancelled: { bg: "rgba(244, 67, 54, 0.08)", color: "rgb(211, 47, 47)" },
  "Closed Referral": { bg: "rgba(0, 0, 0, 0.08)", color: "rgba(0, 0, 0, 0.54)" },
};

const defaultConfig = { bg: "rgba(0, 0, 0, 0.04)", color: "rgba(0, 0, 0, 0.54)" };

const useStyles = makeStyles<Theme, { bg: string; color: string }>(() => ({
  chip: {
    display: "inline-block",
    borderRadius: 12,
    padding: "2px 10px",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "18px",
    whiteSpace: "nowrap",
    backgroundColor: ({ bg }) => bg,
    color: ({ color }) => color,
  },
}));

interface StatusChipProps {
  status: string;
}

const StatusChip: React.VFC<StatusChipProps> = ({ status }) => {
  const config = statusConfig[status] || defaultConfig;
  const classes = useStyles(config);

  if (!status) return <span>-</span>;

  return <span className={classes.chip}>{status}</span>;
};

export default StatusChip;
